"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolve = void 0;
const web3_js_1 = require("@solana/web3.js");
const record_1 = require("./record");
const utils_1 = require("./utils");
const state_1 = require("./state");
const resolve = async (connection, domain) => {
    var _a;
    const { pubkey } = await (0, utils_1.getDomainKey)(domain);
    const { registry, nftOwner } = await state_1.NameRegistryState.retrieve(connection, pubkey);
    if (nftOwner) {
        return nftOwner;
    }
    try {
        const solRecord = await (0, record_1.getSolRecord)(connection, domain);
        const base58 = (_a = solRecord.data) === null || _a === void 0 ? void 0 : _a.toString();
        if (!base58) {
            throw new Error("SOL record is not set");
        }
        return new web3_js_1.PublicKey(base58);
    }
    catch (err) {
        console.log(err);
    }
    return registry.owner;
};
exports.resolve = resolve;
//# sourceMappingURL=resolve.js.map